import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[modal-navigation]',
  standalone: false,
})
export class ModalNavigationDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
